bcn.togglePasswordFields = (function () {

  'use strict';

  return {
    init: function () {

      $('#password_change_button').on('click', function () {
        $('#password_change').removeClass('hidden');
        $(this).addClass('hidden');
        $('#hide_password_fields_button').removeClass('hidden');
      });

      $('#hide_password_fields_button').on('click', function () {
        $('#password_change').addClass('hidden');
        $(this).addClass('hidden');
        $('#password_change_button').removeClass('hidden');
        $('#user_password').val('');
        $('#user_password_confirmation').val('');
        $('#user_current_password').val('');
      });

    }
  };
})();
